import styled from 'styled-components';

export const LightboxDocumentPdf = styled.object.attrs({
    'data-testid': 'lightbox-document-element-pdf',
    height: '100%',
    type: 'application/pdf',
    width: '100%',
})`
    height: 80vh;
    width: 100%;
    max-width: 80vh;
`;
